new MutationObserver((_, obs) => {
  const el = document.getElementById('100366-phone-1');
  if (el) {
    el.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{0,4})/, '($1) $2-$3');
    });
    obs.disconnect();
  }
}).observe(document.body, { childList: true, subtree: true });

//Google ads tracking
(function () {
  var keys = ['utm_source','utm_medium','utm_campaign','utm_term','campaignid','gclid'];

  // Save params from the URL
  var p = new URLSearchParams(location.search);
  keys.forEach(function (k) {
    if (p.get(k)) localStorage.setItem('trk_' + k, p.get(k));
  });

  // Fill hidden fields by matching their label text
  function fill() {
    document.querySelectorAll('.globo-form-control[data-type="hidden"]').forEach(function (wrap) {
      var label = wrap.querySelector('label.globo-label');
      var input = wrap.querySelector('input[type="hidden"]');
      if (!label || !input) return;

      var name = (label.getAttribute('data-label') || label.textContent || '').trim().toLowerCase();
      var v = localStorage.getItem('trk_' + name);
      if (keys.indexOf(name) !== -1 && v && !input.value) {
        input.value = v;
        input.dispatchEvent(new Event('input',  { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  new MutationObserver(fill).observe(document.body, { childList: true, subtree: true });
  fill();
})();

//push event load on contact us and quote page
(function () {
  var allowedPaths = ['/pages/request-quote', '/pages/contactus'];
  var path = window.location.pathname.replace(/\/$/, '').toLowerCase();
  if (allowedPaths.indexOf(path) === -1) return;
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ event: 'form_start' });
})();